import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-nieuwsbrief',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconNieuwsbrief {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M19.41.49C19.01.17 18.51 0 18 0s-1.01.18-1.41.49l-2.2 1.76h7.2L19.39.49Zm-4.73 21.45.37-.3h.01l.8-.58c.63-.46 1.38-.69 2.13-.69s1.56.25 2.2.74l1.9 1.41 9.42-6.76V4.5H4.5v11.23l9.43 6.77zM9 7.84h18a1.129 1.129 0 1 1 0 2.26H9a1.129 1.129 0 1 1 0-2.26m0 4.51h18a1.129 1.129 0 1 1 0 2.26H9a1.129 1.129 0 1 1 0-2.26m1.16 4.5h6.7a1.129 1.129 0 1 1 0 2.26H12.9l-2.74-2.25Zm23.59-4.87v2.5l1.68-1.16zm-31.5 0L.57 13.32l1.68 1.16zM0 15.66v18.15l12.09-9.77zm20.74 8.67-1.93-1.43c-.23-.18-.53-.28-.83-.28-.2 0-.51.04-.78.24l-1.14.85L.93 35.96c.07.01.13.04.2.04H33.8L21.54 24.92l-.79-.58Zm3.18-.29 12.07 10.91s.01-.05.01-.07V15.66l-12.08 8.37Z"/>
</svg>

    );
  }
}
